// Fetch Request
import fetch from '../../../core/fetch';
import history from '../../../core/history';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({ restrictType: 'popularLocation', restrictValue: values?.id }));
  if (isRestrict) return;
  const dynamicPopularLocation = values?.dynamicPopularLocation?.length > 0 ? JSON.stringify(values.dynamicPopularLocation) : JSON.stringify([]);
  
  const mutation = `
  mutation updatePopularLocation(
    $id: Int,
    $location: String,
    $locationAddress: String,
    $image: String,
    $dynamicPopularLocation: String,
  ) {
    updatePopularLocation(
      id: $id,
      location: $location,
      locationAddress: $locationAddress,
      image: $image,
      dynamicPopularLocation: $dynamicPopularLocation,
    ) {
        status
    }
  }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: mutation,
      variables: {
        ...values,
        location: values?.dynamicPopularLocation?.[0]?.location,
        dynamicPopularLocation
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();


  if (data.updatePopularLocation.status === "success") {
    showToaster({ messageId: 'updatePopularLocation', toasterType: 'success' })
    history.push('/siteadmin/popularlocation');
  } else {
    showToaster({ messageId: 'updatePopularLocationFailed', toasterType: 'error' })
  }

}

export default submit;
